import { render } from "./LuckyNumberHistory.vue?vue&type=template&id=5dd64997"
import script from "./LuckyNumberHistory.vue?vue&type=script&lang=js"
export * from "./LuckyNumberHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__